(function () {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputSelect', cpInputSelect)
        .directive('cpInputSelectEmptyValue', cpInputSelectEmptyValue);

    cpInputSelect.$inject = [];

    function cpInputSelect() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-select/input-select.html',
            scope: {
                title: '@',
                noCol: '@',
                noEmptyOpt: '@',
                object: '=',
                prop: '@',
                options: '=',
                optionPropTitle: '@',
                optionPropValue: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?'
            },
            link: function (scope, element, attrs, controller) {
            }
        };
    }

    cpInputSelectEmptyValue.$inject = [];

    function cpInputSelectEmptyValue() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    if (value === null) {
                        value = '';
                    }
                    return value;
                });
            }
        };
    }
})();
